<template>
    <div class="timesheet-conflict-sources">
        <div v-for="(entry, index) in entries" :key="index" class="mb-2">
            <template v-if="!authorOnly">
                <a v-if="sourceRoute(entry)" :href="$router.resolve(sourceRoute(entry)).href"
                   target="_blank" rel="noopener noreferrer" @click.stop>{{ sourceName(entry) }}</a>
                <span v-else>{{ sourceName(entry) }}</span>: <strong>{{ mark(entry) }}</strong>.
            </template>
            <span v-if="entry.author_user_id">
                Отметку поставил:
                <EmployeeLink :user-id="entry.author_user_id" :fallback="entry.author_name" compact @open="notifyOpen" />.
            </span>
            <span v-else>{{ entry.author_name || 'Кто поставил отметку — неизвестно' }}.</span>
        </div>
    </div>
</template>

<script>
import sources from '@/utils/timesheetConflictSources';
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {
    components: {EmployeeLink},
    props: {entries: {type: Array, default: () => []}, authorOnly: Boolean},
    methods: {
        mark: sources.mark,
        sourceName: sources.sourceName,
        sourceRoute: sources.route,
        notifyOpen() {
            this.$emit('open-author');
        }
    }
};
</script>
